var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuFlag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9941_3046)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9941_3046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5 20C43.5 32.7025 33.2025 43 20.5 43C7.79753 43 -2.5 32.7025 -2.5 20C-2.5 20.0054 20.5 -2.99739 20.5 -3C33.2025 -3 43.5 7.29753 43.5 20Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4385 20H20.5C20.5 19.9792 20.5 19.9592 20.5 19.9385C20.4795 19.9591 20.459 19.9795 20.4385 20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8.99998C20.5 4.95297 20.5 2.30105 20.5 -3H20.4961C7.79537 -2.99793 -2.5 7.29861 -2.5 19.9999H9.49998V13.2426L16.2573 19.9999H20.4385C20.4591 19.9794 20.4796 19.9589 20.5001 19.9384C20.5001 18.3888 20.5001 17.0062 20.5001 15.7574L13.7427 8.99998H20.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13611 0C5.53886 2.04835 2.54832 5.03889 0.499969 8.63614V20H6.5V6.00012V6.00004H20.5C20.5 4.10766 20.5 2.30485 20.5 0H9.13611Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 17.1715L12.3284 9.00004H9.50007C9.50007 8.99995 9.50007 9.00004 9.50007 9.00004L20.4999 19.9999H20.5C20.5 19.9999 20.5 18.0498 20.5 17.1715Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3714 24L12.6337 26.6394L15.4842 25.9806L14.2077 28.6132L16.5 30.431L13.6459 31.0743L13.6539 34L11.3714 32.1696L9.08903 34L9.09703 31.0743L6.24287 30.431L8.53524 28.6132L7.25856 25.9806L10.1092 26.6394L11.3714 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9357 29L32.5668 30.3197L33.9921 29.9903L33.3538 31.3066L34.5 32.2155L33.0729 32.5371L33.0769 34L31.9357 33.0847L30.7945 34L30.7984 32.5371L29.3714 32.2155L30.5176 31.3066L29.8793 29.9903L31.3045 30.3197L31.9357 29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0643 15L26.6954 16.3198L28.1206 15.9903L27.4824 17.3066L28.6285 18.2155L27.2015 18.5371L27.2054 20L26.0643 19.0847L24.9231 20L24.927 18.5371L23.5 18.2155L24.6461 17.3066L24.0079 15.9903L25.4331 16.3198L26.0643 15Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9357 7L32.5668 8.3198L33.9921 7.99035L33.3539 9.30665L34.4999 10.2155L33.0729 10.5372L33.0769 12.0001L31.9357 11.0848L30.7945 12.0001L30.7984 10.5372L29.3714 10.2155L30.5175 9.30665L29.8793 7.99035L31.3045 8.3198L31.9357 7Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0643 13L37.6954 14.3198L39.1207 13.9903L38.4824 15.3066L39.6285 16.2155L38.2015 16.5372L38.2054 18L37.0643 17.0848L35.9231 18L35.927 16.5372L34.5 16.2155L35.6461 15.3066L35.0079 13.9903L36.4331 14.3198L37.0643 13Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3971 20L33.8935 21.5279H35.5L34.2003 22.4722L34.6968 24L33.3971 23.0558L32.0974 24L32.5938 22.4722L31.2941 21.5279H32.9006L33.3971 20Z",
    fill: "#F0F0F0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9941_3046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9941_3046"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.5 20C-2.5 7.29745 7.79745 -3 20.5 -3C33.2025 -3 43.5 7.29745 43.5 20C43.5 32.7025 33.2025 43 20.5 43C7.79745 43 -2.5 32.7025 -2.5 20Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuFlag);
export default __webpack_public_path__ + "static/media/au-flag.d5a44f288a0f426807cf0f85302416ec.svg";
export { ForwardRef as ReactComponent };